import { useMemo } from 'react';
import type { PermissionsProviderProps } from './PermissionsContext';
import { PermissionsContext } from './PermissionsContext';

export default function PermissionsProvider({
  children,
}: PermissionsProviderProps) {
  const contextValue = useMemo(() => ({}), []);
  return (
    <PermissionsContext value={contextValue}>{children}</PermissionsContext>
  );
}

PermissionsProvider.displayName = 'PermissionsProvider';
